import { z } from 'zod'

export const saveCartFormSchema = z.object({
  name: z.string().trim().min(1).max(255),
  description: z.string().trim().max(2000).optional(),
})

export type SaveCartFormValues = z.infer<typeof saveCartFormSchema>

export const savedCartChildSchema = z.object({
  referencedId: z.string().min(1),
  quantity: z.number().int().positive(),
  type: z.string().min(1),
})

export const savedCartItemSchema = z.object({
  referencedId: z.string().min(1),
  quantity: z.number().int().positive(),
  type: z.string().min(1),
  label: z.string().optional(),
  children: z.array(savedCartChildSchema).optional(),
})

export type SavedCartChild = z.infer<typeof savedCartChildSchema>
export type SavedCartItem = z.infer<typeof savedCartItemSchema>
